<script lang="ts">
    import { onMount } from "svelte";

    export let cutoffWidth: number = 850
    export let hidden: boolean = false

    let thisElement: HTMLDivElement
    let thisWidth: number = 1000
    onMount(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const { width } = entry.contentRect
                thisWidth = width
            }
        })
        resizeObserver.observe(thisElement)
    })

    $: isMobile = thisWidth < cutoffWidth
</script>

<div bind:this={thisElement} class:hidden class="w-full h-max flex gap-4 flex-nowrap {isMobile ? 'flex-col' : 'flex-row'}">
    {#if isMobile}
        <slot name='left' />
        <slot name='right' />
    {:else}
        <div class="half-flex">
            <slot name='left' />
        </div>
        <div class="half-flex">
            <slot name='right' />
        </div>
    {/if}
</div>

<style>
    .half-flex {
        flex: 1;
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
        flex-wrap: nowrap;
        min-width: 40%;
    }
</style>